import sidebar1 from "@/assets/sidebar-1.jpg"

export default {
  drawer: null,
  color: 'success',
  barColor: 'rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)',
  barImage: sidebar1
}



// WEBPACK FOOTER //
// ./src/store/modules/app/state.js